import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER,
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const message = error?.response?.data?.message;

        if (message === "SESSION_EXPIRED") {
            console.log("SESSION EXPIRED - redirecting");

            localStorage.removeItem("tutor-token");
            localStorage.removeItem("token");
            localStorage.removeItem("student-token");

            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default instance;